import { render } from "./MetricsMonthSendAndReceivedHour.vue?vue&type=template&id=7c0b4120&scoped=true&ts=true"
import script from "./MetricsMonthSendAndReceivedHour.vue?vue&type=script&lang=ts"
export * from "./MetricsMonthSendAndReceivedHour.vue?vue&type=script&lang=ts"

import "./MetricsMonthSendAndReceivedHour.vue?vue&type=style&index=0&id=7c0b4120&scoped=true&lang=css"
import "./MetricsMonthSendAndReceivedHour.vue?vue&type=style&index=1&id=7c0b4120&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0b4120"]])

export default __exports__